<template lang="pug">
    section(:class="[positionClass]")#galeriaNavLateral
        ul(ref="items").items
            li(v-for="item, index in content", :class="{'ativo': ativo == index}").item
                p {{ item.legenda }}
                Imagem(:content="item.image", v-if="item.image")
            SvgIcon(data="@svgs/detalhe_1.svg", original).colors
            .controls
                button(@click="changeImage(ativo - 1)").prev
                    FontAwesomeIcon(:icon="icons.faChevronLeft")
                button(@click="changeImage(ativo + 1)").next
                    FontAwesomeIcon(:icon="icons.faChevronRight")
        ul(ref="items_list").opcoes
            li(v-for="item, index in content", @click="changeImage(index)", :class="{'ativo': ativo == index}").opcao
                p {{ item.legenda }}
</template>

<script>
import { components } from '@/mixins/components'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'

export default {
    name: "component-galeria-nav-lateral",
    components,
    props: {
        content: {
            type: Array,
            required: true
        },
        type: {
            type: String
        },
    },
    data() {
        return {
            ativo: 0,
            icons: {
                faChevronLeft,
                faChevronRight,
            },
        }
    },
    computed: {
        positionClass() {
            if (this.type == 'gallery_textImages_1')
                return 'left'
            return 'right'
        }
    },
    methods: {
        changeImage(index){
            if(index < 0)
                this.ativo = this.$props.content.length - 1
            else if(index > this.$props.content.length - 1)   
                this.ativo = 0
            else 
                this.ativo = index
            
        }
    }
}
</script>

<style lang="stylus" scoped src="./GaleriaNavLateral.styl"></style>